import { Box, keyframes, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useState } from "react";


import { useRemoteField } from "../../hooks/useRemoteField";
import { ESRFieldProps } from "../../types/data";

type ExtraDateProps = {
	mode: "year" | "date";
};
const flashRed = keyframes`
  0% { box-shadow: 0 0 0px rgba(255, 0, 0, 0); }
  30% { box-shadow: 0 0 6px 2px rgba(255, 0, 0, 0.6); }
  100% { box-shadow: 0 0 0px rgba(255, 0, 0, 0); }
`;

export const ESRDateField = (props: ESRFieldProps & ExtraDateProps) => {
	const {
		question_id,
		locked,
		hint_value,
		staticValue,
		show_initial_response,
	} = props;
	const [value, setValue] =
		staticValue != null
			? [staticValue, () => {}]
			: useRemoteField(
					question_id,
					(hint_value.length > 0 && show_initial_response == "x") ? hint_value : "",
				);

	const pickerValue = value && dayjs(value).isValid() ? dayjs(value) : null;
	const [error, setErrorMessage] = useState("");

	const onDateChange = (newVal: any) => {
		const strVal = newVal ? String(newVal) : "";
		if (question_id === "E24" && newVal) {
			const inputDate = new Date(strVal);
			const today = new Date();
			const sixMonthsFromNow = new Date();
			sixMonthsFromNow.setMonth(today.getMonth() + 6);

			if (inputDate < sixMonthsFromNow) {
				setErrorMessage("Choose at least 6 months out");
				setValue("", locked === -1);
				return;
			} else setErrorMessage("");
		}
		if(
			strVal && 
			dayjs(strVal).isValid() && 
			dayjs(strVal).year().toString().length === 4 &&
			strVal !== "Invalid Date"
		) setValue(strVal, locked === -1);
	};

	return (
		<>
			<DatePicker
				views={props.mode === "year" ? ["year"] : ["day"]}
				sx={{ bgcolor: locked ? "#00000011" : "none", width: "100%" }}
				slotProps={{
					textField: {
						id: question_id,
						placeholder: (() => {
							const parsed = dayjs(hint_value);
							if (
								hint_value &&
								parsed.isValid() &&
								show_initial_response === "x"
							) {
								return props.mode === "year"
									? parsed.format("YYYY")
									: parsed.format("MM-DD-YYYY");
							}
							return props.mode === "year" ? "YYYY" : "MM-DD-YYYY";
						})(),
						sx: {
							animation:
								error.length > 0 ? `${flashRed} 0.6s ease-in-out` : "none",
							width: "100%",
						},
					},
				}}
				disabled={locked > 0 || staticValue != undefined}
				value={pickerValue}
				format={props.mode === "year" ? "YYYY" : "MM-DD-YYYY"}
				onChange={onDateChange}
				minDate={props.mode === "year" ? dayjs("1730-01-01") : undefined}
			/>
			{error.length > 0 && (
				<Box>
					<Typography sx={{ color: "#d32f2f", fontSize: "0.875rem", mt: 1 }}>
						{error}
					</Typography>
				</Box>
			)}
		</>
	);
};
